import { TeamBand } from "@/components/TeamBand";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { api } from "@/lib/api";

export default function Conseils() {
  const [articles, setArticles] = useState([]);
  useEffect(() => {
    api.get("/articles").then((r) => setArticles(r.data)).catch(() => {});
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-[148px]" data-testid="conseils-page">
      <section className="max-w-[1400px] mx-auto px-5 md:px-10 py-16 md:py-24">
        <Reveal><p className="overline mb-4" style={{ color: "var(--orange)" }}>Le blog</p></Reveal>
        <Reveal delay={0.05}>
          <h1 className="font-display font-black text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-none">Conseils</h1>
          <p className="mt-6 text-lg max-w-xl" style={{ color: "var(--ink-2)" }}>
            Nos articles et bonnes pratiques sur l'ergonomie, la sécurité, la QVT et la RSE.
          </p>
        </Reveal>
      </section>
      <section className="max-w-[1400px] mx-auto px-5 md:px-10 pb-24 grid grid-cols-1 md:grid-cols-3 gap-px" style={{ background: "var(--border)", border: "1px solid var(--border)" }}>
        {articles.map((a, i) => (
          <Reveal key={a.id} delay={(i % 3) * 0.08}>
            <Link to={`/conseils/${a.slug}`} className="group block h-full" style={{ background: "var(--white)" }} data-testid={`article-card-${a.slug}`}>
              <div className="overflow-hidden">
                <img src={a.image} alt={a.title} className="w-full h-56 object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="p-8">
                <span className="overline" style={{ color: "var(--orange)" }}>{a.category}</span>
                <h3 className="font-display font-bold text-xl mt-3 mb-3">{a.title}</h3>
                <p className="text-sm" style={{ color: "var(--ink-2)" }}>{a.excerpt}</p>
                <span className="mt-5 inline-flex items-center gap-2 text-sm font-semibold link-hover">Lire l'article <ArrowUpRight size={16} /></span>
              </div>
            </Link>
          </Reveal>
        ))}
      </section>
      <TeamBand compact />
    </div>
  );
}
